var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pre',[_vm._v("Custom Object Add Field")]),_c('VueFormGenerator',{attrs:{"schema":_vm.field.schema,"model":_vm.field.model,"options":_vm.field.formOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }